import React, { useState, useEffect, useContext, useRef } from 'react';
import CurrencyService from "../../controller/CurrencyController/CurrencyController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { Link } from "react-router-dom";
import CreateCurrency from './CreateCurrency';
import { API_URL, API_KEY } from "../../../../config/CurrencyConfig";
import { handleSubmit } from "../../controller/CurrencyController/CreateMultiplCurrencies";
import HelpSite from "../../../Common/HelpLink";
import Swal from 'sweetalert2';
import Cookies from "js-cookie";
function CurrencyListPage() {
    const navigate = useNavigate();
    const [currencyList, setCurrencies] = useState([]);
    const { theme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const [modalInstance, setModalInstance] = useState(null);
    const [currentCurrency, setCurrentCurrency] = useState(null);
    const [selectedBaseCurrency, setSelectedBaseCurrency] = useState(null);
    const [CurrencyType, setCurrencyType] = useState(null);

    const [currentPage, setCurrentPage] = useState(1); // Current page
    const UserID = localStorage.getItem("UserID");
    const CompanyID = localStorage.getItem("CompanyID");

    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);
    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };
    const setSortConfigInCookie = (config) => {
        Cookies.set(`CurrencySort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
    };
    const getSortConfigFromCookie = () => {
        const sortCookie = Cookies.get(`CurrencySort_${CompanyID}_${UserID}`);
        return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
    };
    const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const fetchCurrency = async (page, size) => {
        try {
            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();
            const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
            setCurrencies(currencyData);

            // If currency data is empty, trigger sync automatically
            if (!currencyData || currencyData.length === 0) {
                handleSyncClick(); // Sync the data if there's no currency available
            }
        } catch (error) {
            console.error('Error fetching currencies:', error);
        }
    };
    const fetchCustomerCurrency = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const currencyData = await CurrencyService.fetchCustomerCurrency(redirectCallback);
            setCurrencyType(currencyData[0].CurrencyType);

            // If currency data is empty, trigger sync automatically
            if (!currencyData || currencyData.length === 0) {
                handleSyncClick(); // Sync the data if there's no currency available
            }
        } catch (error) {
            console.error('Error fetching currencies:', error);
        }
    };


    useEffect(() => {
        fetchCurrency(currentPage, pageSize);
        fetchCustomerCurrency();

    }, [currentPage, pageSize, selectedBaseCurrency]);
    useEffect(() => {
        fetchCurrency(currentPage, pageSize);

    }, [sortConfig]);

    useEffect(() => {
        setModalInstance(new window.bootstrap.Modal(document.getElementById('currencyModal')));
    }, []);

    const handleCreateCurrencyClick = () => {
        setCurrentCurrency(null);
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleCloseModal = async () => {
        if (modalInstance) {
            modalInstance.hide();
        }
        await fetchCurrency("0", pageSize);
    };
    const handleSuccess = async () => {
        await fetchCurrency("0", pageSize);
    };


    const handleSyncClick = async () => {
        try {
            // Fetch base currency data from 'latest' endpoint
            const ratesResponse = await fetch(`${API_URL}latest?apikey=${API_KEY}`);
            const ratesData = await ratesResponse.json();
            if (ratesData && ratesData.data) {
                const currencyCodes = Object.keys(ratesData.data).join(',');

                // Fetch detailed currency info using the 'currencies' endpoint
                const detailsResponse = await fetch(`${API_URL}currencies?apikey=${API_KEY}&currencies=${currencyCodes}`);
                const detailsData = await detailsResponse.json();

                if (detailsData && detailsData.data) {
                    const updatedCurrencyList = Object.keys(detailsData.data).map((currencyCode) => {
                        const currencyDetail = detailsData.data[currencyCode];
                        return {
                            vc_CurrencyCode: currencyDetail.code,
                            vc_CurrencyName: currencyDetail.name,
                            vc_CurrencySymbol: currencyDetail.symbol_native || currencyDetail.symbol,
                            bit_BaseCurrency: currencyCode === 'USD' ? 1 : 0,
                            dec_CurrencyToBaseRate: ratesData.data[currencyCode] || 'N/A',
                        };
                    });

                    setCurrencies(updatedCurrencyList);
                    setSelectedBaseCurrency('USD');
                    if (currencyList.length === 0) {
                        await handleSubmit(updatedCurrencyList);
                    }
                } else {
                    console.error('Error fetching currency details', detailsData);
                }
            } else {
                console.error('Error fetching currency rates', ratesData);
            }
        } catch (error) {
            console.error('API request failed:', error);
        }
    };
    const handleBaseCurrencyToggle = async (event, currencyCode) => {
        try {
            event.stopPropagation();

            setSelectedBaseCurrency(currencyCode);

            const IsCurrentAlreadyUsed = await CurrencyService.fetchCurrenyUsed();
            const result = IsCurrentAlreadyUsed[0].result;

            if (result === "0" || result === 0) {
                // 1. Update the base currency in the database


                // Convert the currencyList to a comma-separated string of currency codes
                const currencyCodes = currencyList.map(currency => currency.vc_CurrencyCode).join(',');

                // 2. Fetch the latest exchange rates for the newly selected base currency
                const ratesResponse = await fetch(`${API_URL}/latest?apikey=${API_KEY}&currencies=${currencyCodes}&base_currency=${currencyCode}`);
                const ratesData = await ratesResponse.json();

                if (ratesData && ratesData.data) {
                    const newRates = ratesData.data;
                    debugger;
                    // 3. Create a new updated currency list by mapping over the fetched newRates
                    const updatedCurrencyList = Object.keys(newRates).map((currencyCode) => ({
                        vc_CurrencyCode: currencyCode,
                        bit_BaseCurrency: currencyCode === selectedBaseCurrency ? 1 : 0,
                        dec_CurrencyToBaseRate: newRates[currencyCode] || 'N/A',
                        // Optionally retain other properties from currencyList if needed
                        vc_CurrencyName: currencyList.find(c => c.vc_CurrencyCode === currencyCode)?.vc_CurrencyName || '',
                        vc_CurrencySymbol: currencyList.find(c => c.vc_CurrencyCode === currencyCode)?.vc_CurrencySymbol || ''
                    }));
                    debugger;
                    // 4. Save the updated currency data with new exchange rates to the database
                    //  await handleSubmit(updatedCurrencyList);
                    await CurrencyService.UpdateBaseCurrency(updatedCurrencyList, currencyCode);
                    // 5. Update the state with the new currency list
                    setCurrencies(updatedCurrencyList);
                }

                // 6. Refresh the currency list to reflect changes
                await fetchCurrency("0", pageSize);
            }
            else {
                Swal.fire({
                    title: 'Error',
                    text: `The selected currency cannot be changed because it is already in use.`,
                    icon: 'warning'
                });
            }
        } catch (error) {
            console.error('API request failed:', error);
        }
    };


    const handleBaseCurrencyToggle1 = async (currencyCode) => {
        try {
            setSelectedBaseCurrency(currencyCode);

            // 1. Update the base currency in the database
            await CurrencyService.UpdateBaseCurrency(currencyCode);

            // 2. Fetch the latest exchange rates for the newly selected base currency
            const ratesResponse = await fetch(`${API_URL}latest?apikey=${API_KEY}&currencies=${currencyCode}`);
            const ratesData = await ratesResponse.json();

            if (ratesData && ratesData.data) {
                const newRates = ratesData.data;

                // 3. Update the currency list with new exchange rates
                const updatedCurrencyList = currencyList.map((currency) => ({
                    ...currency,
                    bit_BaseCurrency: currency.vc_CurrencyCode === currencyCode ? 1 : 0,
                    dec_CurrencyToBaseRate: newRates[currency.vc_CurrencyCode] || currency.dec_CurrencyToBaseRate
                }));

                setCurrencies(updatedCurrencyList);

                // 4. Call the API to save the updated currency data with new exchange rates to the database
                await handleSubmit(updatedCurrencyList);
            }

            // 5. Refresh the currency list to reflect changes
            await fetchCurrency("0", pageSize);
        } catch (error) {
            console.error('API request failed:', error);
        }
    };
    const handleEditClick = (currency) => {
        setCurrentCurrency(currency); // Set the team to be edited
        if (modalInstance) {
            modalInstance.show();
        }
    };
    const handleDeleteClick = async (ID) => {
        const confirmed = window.confirm("Are you sure you want to delete this team?");
        if (confirmed) {
            try {
                await CurrencyService.DeletCurrency(ID);
                await fetchCurrency("0", pageSize); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting Team:', error);
            }
        }
    };
    const handleFieldChange = async (event) => {
        const { name, value } = event.target;
        if (name === 'CurrencyType') {
            setCurrencyType(value);
            await CurrencyService.SetCustomerCurrency(value);
        }
        // Handle other fields if necessary
    };
    const HelpLink = localStorage.getItem('HelpLink');

    const tableRef = useRef();

    const defaultColumns = [
        "vc_CurrencyName",
        "vc_CurrencyCode",
        "vc_CurrencySymbol",
        "dec_CurrencyToBaseRate"
    ];
    const defaultColumnsForSearch = [
        "vc_CurrencyName",
        "vc_CurrencyCode",
        "vc_CurrencySymbol",
        "dec_CurrencyToBaseRate"

    ];
    const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
    const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
    const columnOptions = [
        { value: "vc_CurrencyName", label: "vc_CurrencyName" },
        { value: "vc_CurrencyCode", label: "vc_CurrencyCode" },
        { value: "vc_CurrencySymbol", label: "vc_CurrencySymbol" },
        { value: "dec_CurrencyToBaseRate", label: "dec_CurrencyToBaseRate" }

    ];
    const columnSearchOptions = [
        { value: "vc_CurrencyName", label: "vc_CurrencyName" },
        { value: "vc_CurrencyCode", label: "vc_CurrencyCode" },
        { value: "vc_CurrencySymbol", label: "vc_CurrencySymbol" },
        { value: "dec_CurrencyToBaseRate", label: "dec_CurrencyToBaseRate" }

    ];
    const handleSearchColumnChange = (selectedOptions) => {
        setSearchColumns(selectedOptions);

    };
    const getStoredColumns = () => {
        const storedColumns = Cookies.get(`currencyColumns_${CompanyID}`);
        return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
    };

    const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
    const handleColumnChange = (selectedOptions) => {
        setVisibleColumns(selectedOptions);

        // Save selection to cookies (valid for 1 year)
        Cookies.set(`currencyColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
    };

    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {
        setCurrentPage(1); // Reset to first page


        let columnsToSearch = searchColumns.length > 0
            ? searchColumns.join(",")
            : "ALL";

        setSearchOptions(columnsToSearch);
        const query = searchQuery.toLowerCase(); // Use current searchQuery state

        const locationData = await CurrencyService.GetAllCurrencies(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setCurrencies(locationData);

    };
    const handleSort = async (key) => {

        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const newConfig = { key, direction };
        setSortConfig(newConfig);
        setSortConfigInCookie(newConfig);
        setCurrentPage(1);
        //   const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        setSortConfig({ key, direction });
        const query = searchQuery.toLowerCase();
        const locationData = await CurrencyService.GetAllCurrencies(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setCurrencies(locationData);

    };
    return (
        <div>
            <div className="row mb-3">
                <label htmlFor="inputText" className="col-sm-2">Select Currency Type:</label>
                <div className="col-sm-3">

                    <select name="CurrencyType" className='form-control' value={CurrencyType}
                        onChange={handleFieldChange}>
                        <option value="Manual">Manual</option>
                        <option value="Auto">Auto</option>
                    </select>
                </div>
                <div className="col-sm-7" style={{ "textAlign": "right" }}>
                    <Link style={{ color: '#ffffff', padding: '5px 8px', marginRight: "10px" }} className='btn btn-primary btn-sm' onClick={handleCreateCurrencyClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </Link>

                    <HelpSite FormName="Currency Setup" Module="26" />
                </div>
            </div>
            <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                <div className="row mb-3">

                    <div className="col-sm-1">
                        <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                            <option value={1000}>1000</option>
                        </select>
                    </div>
                    <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                    <div className="col-sm-6"></div>
                    <div className="col-sm-1 d-flex align-items-center justify-content-end">
                        <span className="me-2">Search</span>


                    </div>
                    <div className="col-sm-2 d-flex justify-content-end">
                        <input
                            list="recent-searches"
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="form-control me-2"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleSearchButtonClick();
                                }
                            }}
                        />

                        <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                            <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                        </button>
                    </div>



                </div>
                <table className="table m-0 table-hover">
                    <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                        <tr>
                            <th onClick={() => handleSort('vc_CurrencyCode')}>Code</th>
                            <th onClick={() => handleSort('vc_CurrencyName')}>Currency</th>
                            <th onClick={() => handleSort('vc_CurrencySymbol')}>Symbol</th>
                            <th onClick={() => handleSort('dec_CurrencyToBaseRate')}>Exchange Rate</th>
                            <th style={{ "textAlign": "right" }}>Default Currency</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currencyList.length === 0 ? (
                            <tr>
                                <td colSpan="4" style={{ textAlign: 'center' }}>No currencies available. Syncing data...</td>
                            </tr>
                        ) : (
                            currencyList.map((currency, index) => (
                                <tr key={index} onClick={() => handleEditClick(currency)}>
                                    <td>{currency.vc_CurrencyCode}</td>
                                    <td>{currency.vc_CurrencyName}</td>
                                    <td>{currency.vc_CurrencySymbol}</td>
                                    <td>{currency.dec_CurrencyToBaseRate}</td>
                                    <td style={{ "textAlign": "right" }}>
                                        <button
                                            className={`btn ${currency.bit_BaseCurrency === 1 ? 'btn-success' : 'btn-secondary'}`}
                                            onClick={(event) => handleBaseCurrencyToggle(event, currency.vc_CurrencyCode)}
                                        >
                                            {currency.bit_BaseCurrency === 1 ? 'On' : 'Off'}
                                        </button>

                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            <CreateCurrency currency={currentCurrency} onClose={handleCloseModal} onSuccess={handleSuccess} />
        </div>
    );
}

export default CurrencyListPage;
